var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(" محاسبات شارژ اعتبار ")]),_c('v-divider'),_c('v-card-text',[_c('service-prices-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }